// Display Banner Ads - Audience Lift Tactic
// Handles file uploads and form management for this specific tactic

import { createUppyUploader } from '../shared/custom_podpromote_uppy_uploader.js'

document.addEventListener('alpine:init', () => {
  Alpine.data('display_banner_ads_audience_lift_x_data', () => ({
    // Form data
    formData: {
      targeting: {
        countries: [],
        podcast_categories: []
      },
      episodes: [],
      cover_art_file: null
    },
    
    init() {
      // Use $nextTick to ensure DOM is fully rendered before loading saved data
      this.$nextTick(() => {
        // Load saved configuration data if available
        this.loadSavedConfiguration();
        
        // Initialize with one episode row by default if no saved episodes
        if (this.formData.episodes.length === 0) {
          this.addEpisodeRow();
        }
        
        this.initializeUppyUploader();
      });
      
      // Set up cleanup when component is destroyed
      this.$cleanup = () => {
        this.cleanup();
      };
    },
    
        // Load saved configuration from backend
    loadSavedConfiguration() {
      try {
        const savedDataDiv = this.$refs.savedConfigData;
        
        if (savedDataDiv) {
          if (savedDataDiv.dataset.savedConfig) {
            const savedConfig = JSON.parse(savedDataDiv.dataset.savedConfig);
            

            
            if (savedConfig) {
              // Load targeting data
              if (savedConfig.targeting) {
                if (savedConfig.targeting.countries) {
                  this.formData.targeting.countries = savedConfig.targeting.countries;
                }
                if (savedConfig.targeting.podcast_categories) {
                  this.formData.targeting.podcast_categories = savedConfig.targeting.podcast_categories;
                }
              }
              
              // Load cover art data
              if (savedConfig.cover_art_file && savedConfig.cover_art_file.url && savedConfig.cover_art_file.url !== 'unknown') {
                this.formData.cover_art_file = savedConfig.cover_art_file;
                
                // Show image preview if cover art exists
                if (this.formData.cover_art_file.url) {
                  this.showImagePreview(this.formData.cover_art_file.url);
                  
                  // Show upload status
                  const statusDiv = document.getElementById('cover-art-upload-status');
                  if (statusDiv) {
                    statusDiv.classList.remove('hidden');
                  }
                }
              }
              
              // Load episodes data
              if (savedConfig.episodes && savedConfig.episodes.length > 0) {
                // Clear existing episodes and load saved ones
                this.formData.episodes = [];
                
                savedConfig.episodes.forEach((savedEpisode, index) => {
                  if (savedEpisode.episode_id) {
                    const newEpisode = {
                      id: `episode_${Date.now()}_${Math.random().toString(36).substr(2, 9)}_${index}`,
                      episode_id: savedEpisode.episode_id,
                      release_date: savedEpisode.release_date || '',
                      apple_link: savedEpisode.apple_link || '',
                      spotify_link: savedEpisode.spotify_link || ''
                    };
                    

                    
                    this.formData.episodes.push(newEpisode);
                  }
                });
                
                // Populate episode select dropdowns with saved data
                this.$nextTick(() => {
                  // Add a small delay to ensure DOM elements are fully rendered
                  setTimeout(() => {
                    this.populateEpisodeSelects();
                    this.populateFormFields();
                  }, 100);
                });
              }
            }
          }
        }
        
      } catch (error) {
        console.error('Error loading saved configuration:', error);
      }
    },
    
    // Populate episode select dropdowns with saved data
    populateEpisodeSelects() {
      this.formData.episodes.forEach((episode, index) => {
        if (episode.episode_id) {
          const selectElement = document.getElementById(`episode-select-${episode.id}`);
          
          if (selectElement) {
            selectElement.value = episode.episode_id;
            // Don't trigger change event to avoid overwriting saved URL data
            // The episode data is already loaded with the correct URLs
          }
        }
      });
    },
    
    // Populate all form fields with saved data
    populateFormFields() {
      // This function ensures all form fields are properly populated
      // The actual population is handled by Alpine.js data binding
    },
    
    initializeUppyUploader() {
      // Check if Uppy uploader is already initialized
      if (window.uppyInstances && window.uppyInstances['audience-lift-cover-art-uploader']) {
        return;
      }
      
      try {
        // Get show ID, campaign ID, and campaign tactic ID
        const showId = this.getShowId();
        const campaignId = this.getCampaignId();
        const campaignTacticId = this.getCampaignTacticId();
        
        if (!showId) {
          console.error('Show ID not found');
          return;
        }
        
        if (!campaignId) {
          console.error('Campaign ID not found');
          return;
        }
        
        if (!campaignTacticId) {
          console.error('Campaign Tactic ID not found');
          return;
        }

        // Initialize Uppy uploader using the modular approach
        // All Uppy logic is outside Alpine, Alpine instance is passed for callbacks
        const uppyInstance = createUppyUploader({
          id: 'audience-lift-cover-art-uploader',
          show_id: showId,
          campaign_id: campaignId,
          campaign_tactic_id: campaignTacticId,
          trigger_id: '#cover-art-upload-trigger',
          max_file_size: 5 * 1024 * 1024, // 5MB
          allowed_file_types: ['image/jpeg', 'image/jpg', 'image/png'],
          max_number_of_files: 1,
          auto_proceed: false,
          close_after_finish: true,
          min_dimensions: { width: 1500, height: 1500 },
          max_dimensions: { width: 1500, height: 1500 },
          note: 'Accepted files: JPG, PNG. Maximum size: 5MB. Accepted dimension: 1500x1500px.',
          on_complete: (result) => {
            this.handleUploadComplete(result);
          },
          on_error: (file, error, response) => {
            this.handleUploadError(file, error, response);
          },
          alpine: this // Pass Alpine instance for callbacks
        });

        // Result object looks like this:
        // {
        //   successful: [
        //     {
        //       id: 'file-id',
        //       name: 'filename.png',
        //       size: 212683,
        //       type: 'image/png',
        //       response: {
        //         status: 200,
        //         body: {
        //           status: 'success',
        //           key: 'staging/.../filename.png',
        //           url: 'https://podpromote-data.s3.amazonaws.com/...',
        //           filename: 'filename.png'
        //         },
        //         uploadURL: 'https://podpromote-data.s3.amazonaws.com/...'
        //       }
        //     }
        //   ],
        //   failed: [],
        //   uploadID: 'unique-upload-id'
        // }
        
        // Store the instance globally to prevent re-initialization
        if (!window.uppyInstances) {
          window.uppyInstances = {};
        }
        window.uppyInstances['audience-lift-cover-art-uploader'] = uppyInstance;
        
      } catch (error) {
        console.error('Failed to initialize Uppy uploader:', error);
      }
    },
    
    getShowId() {
      const urlParts = window.location.pathname.split('/');
      const showIndex = urlParts.indexOf('shows');
      if (showIndex !== -1 && showIndex + 1 < urlParts.length) {
        return urlParts[showIndex + 1];
      }
      return null;
    },

    getCampaignId() {
      const urlParts = window.location.pathname.split('/');
      const campaignIndex = urlParts.indexOf('campaigns');
      if (campaignIndex !== -1 && campaignIndex + 1 < urlParts.length) {
        return urlParts[campaignIndex + 1];
      }
      return null;
    },
    
    getCampaignTacticId() {
      // Try to get from the routes div first
      const routesDiv = this.$refs.routes;
      if (routesDiv && routesDiv.dataset.campaignTacticId) {
        return routesDiv.dataset.campaignTacticId;
      }
      
      // Fallback to URL parsing if needed
      const urlParts = window.location.pathname.split('/');
      const tacticIndex = urlParts.indexOf('campaign-tactics');
      if (tacticIndex !== -1 && tacticIndex + 1 < urlParts.length) {
        return urlParts[tacticIndex + 1];
      }
      
      return null;
    },
    
    handleUploadComplete(result) {
      if (result.successful && result.successful.length > 0) {
        const file = result.successful[0];
        
        // Safety check for this context
        if (!this || !this.formData) {
          console.error('Invalid context in handleUploadComplete:', this);
          return;
        }
        
        // Parse the response to get the S3 data
        let responseData;
        try {
          // Check if response exists and has the expected structure
          if (file.response && file.response.body) {
            responseData = typeof file.response.body === 'string' ? JSON.parse(file.response.body) : file.response.body;
          } else if (file.response) {
            // Fallback: use the response directly if body is not available
            responseData = file.response;
          } else {
            console.warn('No response data available for file:', file);
            responseData = {};
          }
        } catch (e) {
          console.warn('Error parsing response data:', e);
          responseData = file.response || {};
        }
        
        // Extract S3 data from response
        const s3Key = responseData?.key || responseData?.s3_key || 'unknown';
        const s3Url = responseData?.uploadURL || responseData?.url || responseData?.s3_url || 'unknown';
        const filename = responseData?.filename || file.name;
        
        this.formData.cover_art_file = {
          name: file.name,
          size: file.size,
          type: file.type,
          s3_key: s3Key,
          url: s3Url
        };
        
        // Also store in global variable as backup
        window.audienceLiftCoverArtFile = this.formData.cover_art_file;
        
        // Store file data in hidden input
        const hiddenInput = document.getElementById('cover_art_file');
        if (hiddenInput) {
          hiddenInput.value = JSON.stringify(this.formData.cover_art_file);
        } else {
          console.warn('Hidden input not found for cover_art_file');
        }
        
        // Show image preview
        this.showImagePreview(s3Url);
        
        // Show upload status
        const statusDiv = document.getElementById('cover-art-upload-status');
        if (statusDiv) {
          statusDiv.innerHTML = `<div class="flex items-center space-x-2 text-sm text-gray-600">
                <svg class="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>File ${filename} uploaded successfully</span>
              </div>`;
          statusDiv.classList.remove('hidden');
        }
      }
    },
    
    handleUploadError(file, error, response) {
      console.error('Upload error:', file, error, response);
      
      // Safety check for this context
      if (!this || !this.formData) {
        console.error('Invalid context in handleUploadError:', this);
        return;
      }
      
      // Show alert for all validation errors
      let errorMessage = error.message || 'Unknown error occurred';
      
      if (error.message && error.message.includes('dimensions')) {
        errorMessage = `Image Upload Error: ${error.message}\n\nPlease upload an image that is at least 1500x1500 pixels.`;
      } else if (error.message && error.message.includes('size')) {
        errorMessage = `File Size Error: ${error.message}\n\nPlease upload a file smaller than 5MB.`;
      } else if (error.message && error.message.includes('type')) {
        errorMessage = `File Type Error: ${error.message}\n\nPlease upload a JPG or PNG file.`;
      }
      
      alert(errorMessage);
      this.showUploadError(error.message || 'Upload failed');
    },
    
    showUploadSuccess(filename) {
      // Show success message to user
      const statusElement = document.getElementById('cover-art-upload-status');
      if (statusElement) {
        statusElement.classList.remove('hidden');
        const messageElement = statusElement.querySelector('span');
        if (messageElement) {
          messageElement.textContent = `File "${filename}" uploaded successfully!`;
        }
        // Change icon to green checkmark
        const iconElement = statusElement.querySelector('svg');
        if (iconElement) {
          iconElement.classList.remove('text-red-500');
          iconElement.classList.add('text-green-500');
        }
      }
      
      // Show image preview if we have file data
      if (this.formData.cover_art_file && this.formData.cover_art_file.url) {
        this.showImagePreview(this.formData.cover_art_file.url);
      }
    },
    
    showUploadError(message) {
      // Show error message to user
      const statusElement = document.getElementById('cover-art-upload-status');
      if (statusElement) {
        statusElement.classList.remove('hidden');
        const messageElement = statusElement.querySelector('span');
        if (messageElement) {
          messageElement.textContent = message;
        }
        // Change icon to red X
        const iconElement = statusElement.querySelector('svg');
        if (iconElement) {
          iconElement.classList.remove('text-green-500');
          iconElement.classList.add('text-red-500');
        }
      }
      
      // Also show alert for validation errors
      if (message && (message.includes('dimensions') || message.includes('size') || message.includes('type'))) {
        alert(message);
      }
    },
    
    // Episode management
    addEpisodeRow() {
      if (this.formData.episodes.length >= 5) {
        alert('Maximum of 5 episodes allowed');
        return;
      }
      
      // Generate a more unique ID using timestamp + random + index
      const uniqueId = `episode_${Date.now()}_${Math.random().toString(36).substr(2, 9)}_${this.formData.episodes.length}`;
      
      const newEpisode = {
        id: uniqueId,
        episode_id: '',
        release_date: '',
        apple_link: '',
        spotify_link: ''
      };
      
      this.formData.episodes.push(newEpisode);
      
      // No manual event listeners needed - using Alpine.js @change directive
    },

    removeEpisodeRow(episodeId) {
      // Don't allow removing the last episode row
      if (this.formData.episodes.length <= 1) {
        return;
      }
      
      // Find the index of the episode to remove
      const indexToRemove = this.formData.episodes.findIndex(episode => episode.id === episodeId);
      
      if (indexToRemove !== -1) {
        // Remove the episode from the array
        this.formData.episodes.splice(indexToRemove, 1);
      } else {
        return;
      }
      
      // No manual event listeners needed - using Alpine.js @change directive
    },

    handleEpisodeSelection(episodeId, index) {
      if (episodeId && this.formData.episodes[index]) {
        // Check if this episode is already selected in another row
        const isDuplicate = this.formData.episodes.some((episode, idx) => 
          idx !== index && episode.episode_id === episodeId
        );
        
        if (isDuplicate) {
          // Find the duplicate episode to show which row it's in
          const duplicateIndex = this.formData.episodes.findIndex((episode, idx) => 
            idx !== index && episode.episode_id === episodeId
          );
          
          alert(`This episode is already selected in row ${duplicateIndex + 1}. Please select a different episode.`);
          
          // Reset the select dropdown to empty
          this.$nextTick(() => {
            const selectElement = document.getElementById(`episode-select-${this.formData.episodes[index].id}`);
            if (selectElement) {
              selectElement.value = '';
            }
          });
          
          // Clear the episode data for this row
          this.formData.episodes[index].episode_id = '';
          this.formData.episodes[index].release_date = '';
          this.formData.episodes[index].apple_link = '';
          this.formData.episodes[index].spotify_link = '';
          
          return;
        }
        
        this.formData.episodes[index].episode_id = episodeId;
        
        // Find the selected episode data from the backend episodes
        const selectedEpisode = this.findEpisodeById(episodeId);
        
        if (selectedEpisode) {
          // Handle pub_date
          if (selectedEpisode.pub_date) {
            const formattedDate = this.formatDate(selectedEpisode.pub_date);
            this.formData.episodes[index].release_date = formattedDate;
          } else {
            this.formData.episodes[index].release_date = 'Release date not available';
          }
          
          // Handle distribution platforms (Apple and Spotify links)
          if (selectedEpisode.distribution_platforms) {
            const platforms = selectedEpisode.distribution_platforms;
            
            // Set Apple link using itunes_url key
            if (platforms.itunes_url) {
              this.formData.episodes[index].apple_link = platforms.itunes_url;
            } else {
              this.formData.episodes[index].apple_link = '';
            }
            
            // Set Spotify link using spotify_url key
            if (platforms.spotify_url) {
              this.formData.episodes[index].spotify_link = platforms.spotify_url;
            } else {
              this.formData.episodes[index].spotify_link = '';
            }
          } else {
            this.formData.episodes[index].apple_link = '';
            this.formData.episodes[index].spotify_link = '';
          }
        }
      }
    },

    // Find episode by ID from the backend data
    findEpisodeById(episodeId) {
      // Get episodes data from the template data attribute
      const episodesDataDiv = this.$refs.episodesData;
      let episodesData = [];
      
      if (episodesDataDiv && episodesDataDiv.dataset.episodes) {
        try {
          episodesData = JSON.parse(episodesDataDiv.dataset.episodes);
        } catch (e) {
          console.error('Error parsing episodes data:', e);
        }
      }
      
      if (!episodesData || episodesData.length === 0) {
        return null;
      }
      
      const foundEpisode = episodesData.find(episode => episode.id == episodeId);
      return foundEpisode;
    },

    // Format date for display
    formatDate(dateString) {
      if (!dateString) return 'Date not available';
      
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'Invalid date';
        
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      } catch (error) {
        console.error('Error formatting date:', error);
        return 'Date not available';
      }
    },

    // Initialize episode select event listeners
    initializeEpisodeSelects() {
      // No manual event listeners needed - using Alpine.js @change directive
    },
    
    refreshRssFeed() {
      alert('RSS feed refresh functionality is not yet implemented. Please contact support.');
    },

    // Get the stored file data for form submission
    getFileData() {
      return this.formData.cover_art_file;
    },

    // Check if file is uploaded
    hasFileUploaded() {
      return this.formData.cover_art_file && this.formData.cover_art_file.url !== 'unknown';
    },

    // Show image preview
    showImagePreview(imageUrl = null) {
      try {
        const previewElement = document.getElementById('cover-art-preview');
        const previewImage = document.getElementById('preview-image');
        
        if (previewElement && previewImage) {
          // Use provided URL or fall back to formData
          const urlToShow = imageUrl || (this.formData.cover_art_file && this.formData.cover_art_file.url);
          
          if (urlToShow && urlToShow !== 'unknown') {
            previewImage.src = urlToShow;
            previewElement.classList.remove('hidden');
          } else {
            previewElement.classList.add('hidden');
          }
        } else {
          console.warn('Preview elements not available:', {
            previewElement: !!previewElement,
            previewImage: !!previewImage
          });
        }
      } catch (error) {
        console.error('Error showing image preview:', error);
      }
    },
    
    // Clear uploaded file data
    clearFileData() {
      this.formData.cover_art_file = null;
      const hiddenInput = document.getElementById('cover_art_file');
      if (hiddenInput) {
        hiddenInput.value = '';
      }
      const statusElement = document.getElementById('cover-art-upload-status');
      if (statusElement) {
        statusElement.classList.add('hidden');
      }
      
      // Hide image preview
      const previewElement = document.getElementById('cover-art-preview');
      if (previewElement) {
        previewElement.classList.add('hidden');
      }
    },
    
    // Add country to selection
    addCountry(country) {
      if (country && !this.formData.targeting.countries.includes(country)) {
        this.formData.targeting.countries.push(country);
        // Reset the select dropdown
        const selectElement = document.querySelector('select[data-country-select]');
        if (selectElement) selectElement.value = '';
      }
    },
    
    // Remove country from selection
    removeCountry(country) {
      const index = this.formData.targeting.countries.indexOf(country);
      if (index > -1) {
        this.formData.targeting.countries.splice(index, 1);
      }
    },
    
    // Add podcast category to selection
    addPodcastCategory(category) {
      if (category && !this.formData.targeting.podcast_categories.includes(category)) {
        this.formData.targeting.podcast_categories.push(category);
        // Reset the select dropdown
        const selectElement = document.querySelector('select[data-podcast-category-select]');
        if (selectElement) selectElement.value = '';
      }
    },
    
    // Remove podcast category from selection
    removePodcastCategory(category) {
      const index = this.formData.targeting.podcast_categories.indexOf(category);
      if (index > -1) {
        this.formData.targeting.podcast_categories.splice(index, 1);
      }
    },
    
    // Format category for display (convert snake_case to Title Case)
    formatCategoryDisplay(category) {
      if (!category) return '';
      return category
        .replace(/_/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
    },
    
    // Save form configuration
    saveForm() {
      try {
        // Validate required fields
        if (this.formData.targeting.countries.length === 0) {
          alert('Please select at least one country for targeting.');
          return;
        }
        
        if (this.formData.targeting.podcast_categories.length === 0) {
          alert('Please select at least one podcast category.');
          return;
        }
        
        // Check global backup if local formData doesn't have cover art
        if (!this.formData.cover_art_file || this.formData.cover_art_file.url === 'unknown') {
          if (window.audienceLiftCoverArtFile && window.audienceLiftCoverArtFile.url !== 'unknown') {
            this.formData.cover_art_file = window.audienceLiftCoverArtFile;
          } else {
            alert('Please upload show cover art before saving.');
            return;
          }
        }
        
        if (this.formData.episodes.length === 0 || this.formData.episodes.every(ep => !ep.episode_id)) {
          alert('Please select at least one episode to highlight.');
          return;
        }
        
        // Prepare data for submission
        const formDataToSubmit = {
          targeting: {
            countries: this.formData.targeting.countries,
            podcast_categories: this.formData.targeting.podcast_categories
          },
          cover_art_file: this.formData.cover_art_file,
          episodes: this.formData.episodes.filter(ep => ep.episode_id).map(ep => ({
            episode_id: ep.episode_id,
            release_date: ep.release_date,
            apple_link: ep.apple_link,
            spotify_link: ep.spotify_link
          }))
        };
        
        // Get the campaign tactic ID from the routes div
        const routesDiv = this.$refs.routes;
        const campaignTacticId = routesDiv?.dataset?.campaignTacticId;
        
        if (!campaignTacticId) {
          alert('Campaign tactic ID not found. Please refresh the page and try again.');
          return;
        }
        
        // Get the current URL to extract show and campaign IDs
        const urlParts = window.location.pathname.split('/');
        const showIndex = urlParts.indexOf('shows');
        const campaignIndex = urlParts.indexOf('campaigns');
        
        if (showIndex === -1 || campaignIndex === -1) {
          alert('Invalid URL structure. Please refresh the page and try again.');
          return;
        }
        
        const showId = urlParts[showIndex + 1];
        const campaignId = urlParts[campaignIndex + 1];
        
        // Get the submit link from the routes template
        const routesTemplate = this.$refs.routes;
        const submitLink = routesTemplate?.dataset?.submitLink;
        
        // Create a hidden form and submit it
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = submitLink;
        
        // Add CSRF token
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (csrfToken) {
          const csrfInput = document.createElement('input');
          csrfInput.type = 'hidden';
          csrfInput.name = 'authenticity_token';
          csrfInput.value = csrfToken;
          form.appendChild(csrfInput);
        }
        
        // Add method override for PATCH
        const methodInput = document.createElement('input');
        methodInput.type = 'hidden';
        methodInput.name = '_method';
        methodInput.value = 'PATCH';
        form.appendChild(methodInput);
        
        // Add form data as JSON
        const formDataInput = document.createElement('input');
        formDataInput.type = 'hidden';
        formDataInput.name = 'form_data';
        formDataInput.value = JSON.stringify(formDataToSubmit);
        form.appendChild(formDataInput);
        

        
        // Add to DOM and submit
        document.body.appendChild(form);
        form.submit();
        
      } catch (error) {
        console.error('Error saving form:', error);
        alert('Error saving configuration. Please try again.');
      }
    },

    // Save as draft (no validations)
    saveAsDraft() {
        // Check global backup if local formData doesn't have cover art
        if (!this.formData.cover_art_file || this.formData.cover_art_file.url === 'unknown') {
          if (window.audienceLiftCoverArtFile && window.audienceLiftCoverArtFile.url !== 'unknown') {
            this.formData.cover_art_file = window.audienceLiftCoverArtFile;
          }
        }
        
        // Prepare data for submission (same as saveForm but without validations)
        const formDataToSubmit = {
          targeting: {
            countries: this.formData.targeting.countries,
            podcast_categories: this.formData.targeting.podcast_categories
          },
          cover_art_file: this.formData.cover_art_file,
          episodes: this.formData.episodes.filter(ep => ep.episode_id).map(ep => ({
            episode_id: ep.episode_id,
            release_date: ep.release_date,
            apple_link: ep.apple_link,
            spotify_link: ep.spotify_link
          }))
        };
        
        // Get the save as draft link from the routes template
        const routesTemplate = this.$refs.routes;
        const saveAsDraftLink = routesTemplate?.dataset?.saveAsDraftLink;
        
        // Create a hidden form and submit it
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = saveAsDraftLink;
        form.style.display = 'none';
        
        // Add CSRF token
        const csrfInput = document.createElement('input');
        csrfInput.type = 'hidden';
        csrfInput.name = 'authenticity_token';
        csrfInput.value = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
        form.appendChild(csrfInput);
        
        // Add method override for PATCH
        const methodInput = document.createElement('input');
        methodInput.type = 'hidden';
        methodInput.name = '_method';
        methodInput.value = 'patch';
        form.appendChild(methodInput);
        
        // Add form data
        const formDataInput = document.createElement('input');
        formDataInput.type = 'hidden';
        formDataInput.name = 'form_data';
        formDataInput.value = JSON.stringify(formDataToSubmit);
        form.appendChild(formDataInput);
        
        // Add to DOM and submit
        document.body.appendChild(form);
        form.submit();
    },
    
    // Cleanup function to be called when component is destroyed
    cleanup() {
      try {
        // Clean up Uppy instance if it exists
        if (window.uppyInstances && window.uppyInstances['audience-lift-cover-art-uploader']) {
          const uppyInstance = window.uppyInstances['audience-lift-cover-art-uploader'];
          if (uppyInstance && typeof uppyInstance.cleanup === 'function') {
            uppyInstance.cleanup();
          }
          delete window.uppyInstances['audience-lift-cover-art-uploader'];
        }
      } catch (error) {
        console.warn('Error during component cleanup:', error);
      }
    }
  }));
});
